import '@/vendor/font_awesome/light.min'
import '@/vendor/font_awesome/fontawesome.min'
import Rails from '@rails/ujs'
Rails.start()